import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/owner-list';
import ViewComponent from './components/owner-view';

import _ from "lodash";
import mapByUserName from "../../import/normalize/map-user";
import SystemFieldUserViewInImport from "../../import/view-in-preview/user-view-in-preview";

//projects only field
export default class OwnerField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.OWNER;
    }

    get sortHintMessage() {
        return 'Sort by owner';
    }

    getCsvValue(item) {
        const owner = item.users ? _.find(item.users, u=>u.role === gd.const.project.role.OWNER) : null;
        return owner ? gd.session.users.get(owner.id).name : 'Not assigned';
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => {
                const owner = i.item.users ? _.find(i.item.users, u=>u.role === gd.const.project.role.OWNER) : null;
                return !owner ? '-' : gd.session.users.get(owner.id).name.toLowerCase()
            }],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, 'gd-field-owner', 'Not assigned');
    }

    get ViewComponent() {
        return ViewComponent.bind(null, 'gd-field-owner', 'Not assigned');
    }

    // IMPORT

    normalizeCSVValue(value) {
        return mapByUserName(gd.companyId, value);
    }

    getComponentViewInImport() {
        return SystemFieldUserViewInImport;
    }
}